<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title">Contents</p>
<p class="toc"><a href="#/xhtml/06_Preface">Preface</a></p>
<p class="toc1"><a href="#/xhtml/06_Preface">Modern Warfare Series</a></p>
<p class="toc"><a href="#/xhtml/07_Introduction">Introduction</a></p>
<p class="toc1"><a href="#/xhtml/07_Introduction">Saddam Betrayed</a></p>
<p class="toca"><a href="#/xhtml/08_Chapter01">Chapter One</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01">Babylon Lion</a></p>
<p class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">Coalition of the Willing</span></p>
<p class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc1"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Marines Storm Basra</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc1"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Sixteen Days to Baghdad</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc1"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Where’s Saddam’s Air Force?</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc1"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">The Fate of Saddam’s Navy</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">A Tarnished Reputation</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">Zarqawi’s Storm</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">The Battle for Fallujah</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">Phoenix from the Ashes</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">Where did it all go Wrong?</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="toc1"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">What Happened to Saddam’s WMD?</span></p>
<p class="toc1a"><span href="#/xhtml/20_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc2"><span href="#/xhtml/21_Suggested_Further_Reading" title="Link target outside of Sample">Suggested Further Reading</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?32ab5dd0